import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { ButtonComp } from 'atoms/Buttons';
import { ADDRESS_STORE_CONSTANTS } from '../../Constants/Constants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { getValueOrnull } from 'common/utilities/utils';

const DeliveryAddressView = props => {
  const { savedAddresses, addOrEditClickHandler, deleteAddressHandler } = props;

  const { EDIT, DELETE, ADD_NEW_ADDRESS, ADD, DEFAULT } = ADDRESS_STORE_CONSTANTS;

  const { APT_SUITE_FLOOR, DELIVERY_OPTIONS, DELIVERY, INSTRUCTIONS } = TRANSLATE_MAPPING_KEY;

  const sortAddress = savedAddres => {
    return savedAddres.sort((a, b) => {
      return b.isPrimary - a.isPrimary;
    });
  };

  const addressCard = sortAddress(savedAddresses).map(item => {
    const { addressLines, city, state, pinCode, country, name, isPrimary, id, deliveryOptions, deliveryInstructions } =
      item;
    return (
      <React.Fragment>
        <div className='delivery-card bgv-set d-flex'>
          <div className='address-description d-flex'>
            <p className='address-mode address-mode-global'>
              <span className='text-transform-capitalize delivery-store-name'>
                <strong>{name}</strong>
              </span>{' '}
              {isPrimary ? <span>{`(${translateWithI18Next(DEFAULT)})`}</span> : ''}
            </p>
            <div className='delivery-details'>
              <span className='address-street-text'>
                {getValueOrnull(addressLines[1])} {getValueOrnull(city)}
              </span>
              <span>{`${getValueOrnull(state)}, ${getValueOrnull(pinCode)}, ${getValueOrnull(country)}`}</span>
              {addressLines[0] && (
                <span className='address-heading'>
                  {translateWithI18Next(APT_SUITE_FLOOR)}
                  <strong>: {addressLines[0]}</strong>
                </span>
              )}
              {deliveryOptions && (
                <span className='address-heading'>
                  {translateWithI18Next(DELIVERY_OPTIONS)?.toLowerCase()}
                  <strong>
                    : <span className='address-text'>{translateWithI18Next(deliveryOptions)}</span>
                  </strong>
                </span>
              )}
              {deliveryInstructions && (
                <span className='address-heading'>
                  {translateWithI18Next(DELIVERY)?.toLowerCase()} {translateWithI18Next(INSTRUCTIONS)?.toLowerCase()}
                  <strong>
                    : <span className='address-text-Instructions'>{deliveryInstructions}</span>
                  </strong>
                </span>
              )}
            </div>
          </div>
          <div className='action-btn d-flex'>
            <div
              onClick={() => addOrEditClickHandler(EDIT, item)}
              data-testid='edit-testid'
              className='anchor-info edit-adjust'
            >
              {translateWithI18Next(EDIT)}
            </div>
            <div
              onClick={() => deleteAddressHandler(id)}
              data-testid='delete-testid'
              className='anchor-info del-adjust'
            >
              {translateWithI18Next(DELETE)}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  });

  return (
    <div className='address-section'>
      {savedAddresses?.length > 0 && addressCard}
      <div className='add-address'>
        <ButtonComp
          data-testid='add-testid'
          onClickHandler={() => addOrEditClickHandler(ADD)}
          className={`mt-10 button font-bold whiteButton blackBorder`}
        >
          {translateWithI18Next(ADD_NEW_ADDRESS)}
        </ButtonComp>
      </div>
    </div>
  );
};

export default DeliveryAddressView;
